module.exports = {
      id: "subscribe-vikatan-usage",
      viewBox: "0 0 365.232 27",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#subscribe-vikatan",
      toString: function () {
        return this.url;
      }
    }